// app/javascript/controllers/group_privileges_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { }

  connect() {
    console.log('connecting row')
    // Initialize when connected
    const privilegeSelect = this.element.querySelector('select.privilege')
    if (privilegeSelect && privilegeSelect.value) {
      this.updatePrivilegeFields(privilegeSelect)
    }
  }

  // Handle privilege selection change
  handlePrivilegeChange(event) {
    console.log('handling privilege change')
    this.updatePrivilegeFields(event.target)
  }

  // Update visibility of related fields based on selected privilege
  updatePrivilegeFields(select) {
    // Find the related fields in this wrapper
    const wrapper = this.element

    const recipient = wrapper.querySelector('.recipient')
    const thirdParty = wrapper.querySelector('.third_party')
    const parameter = wrapper.querySelector('.parameter')

    // Get the selected privilege's properties using window.privilegesHash
    const privilegeId = select.value

    if (privilegeId && window.privilegesHash && window.privilegesHash[privilegeId]) {
      const hasRecipient = window.privilegesHash[privilegeId]["has_recipient"]
      const hasThirdParty = window.privilegesHash[privilegeId]["has_third_party"]
      const hasParameter = window.privilegesHash[privilegeId]["has_parameter"]

      // Show/hide fields based on privilege properties
      hasRecipient ? recipient.classList.remove('hidden') : recipient.classList.add('hidden')
      hasThirdParty ? thirdParty.classList.remove('hidden') : thirdParty.classList.add('hidden')
      hasParameter ? parameter.classList.remove('hidden') : parameter.classList.add('hidden')
    }
  }
}
